import * as UnicourtAttorney from '../../../litigation/state/db/UnicourtAttorney.selectors';
import * as UnicourtCase from '../../../litigation/state/db/UnicourtCase.selectors';

import { DOMAIN, getStore } from './DB.store';

import get from 'lodash/get';

/*
 * These must stay live namespace re-exports: `export const x = Namespace`
 * snapshots the namespace by value at evaluation time, and if a cycle ever
 * reaches this module first the snapshot captures `undefined` permanently.
 * `export * as` binds lazily, so evaluation order cannot break it.
 */
export * as audit from './audit/Audit.selectors';
export * as breach from '/b2b/vendors/state/db/Breach.selectors';
export * as category from './category/Category.selectors';
export * as consentConfig from '../../../consent/state/db/ConsentConfig.selectors';
export * as customer from './customer/Customer.selectors';
export * as dataStore from '../../../dataStores/state/db/DataStore.selectors';
export * as document from '../../../documents/state/db/Document.selectors';
export * as domain from './domain/Domain.selectors';
export * as dsarActionItem from '../../../dsarActionItems/state/db/ActionItem.selectors';
export * as dsarForm from '../../../dsarForms/state/db/Form.selectors';
export * as dsarRequest from '../../../dsarRequests/state/db/Request.selectors';
export * as dsarRequestType from '../../../dsarRequests/state/db/RequestType.selectors';
export * as helpScout from '../../../askAnalyst/state/db/HelpScout.selectors';
export * as iab from './iab/Iab.selectors';
export * as jurisdiction from '../../../legislation/state/db/Jurisdiction.selectors';
export * as legislation from '../../../legislation/state/db/Legislation.selectors';
export * as litigation from '../../../litigation/state/db/Litigation.selectors';
export * as notification from '../../../notifications/state/db/Notification.selectors';
export * as organization from '../../../organizations/state/db/Organization.selectors';
export * as product from '/b2b/vendors/state/db/Product.selectors';
export * as role from './role/Role.selectors';
export * as subscription from './subscription/Subscription.selectors';
export * as template from '../../../assessments/state/db/Template.selectors';
export * as trusthub from '../../../trusthub/state/db/Trusthub.selectors';
export * as user from '../../../users/state/db/User.selectors';
export * as vendor from '/b2b/vendors/state/db/Vendor.selectors';
// Getters rather than plain properties, for the same evaluation-order reason.
export const unicourt = {
    get attorney() {
        return UnicourtAttorney;
    },
    get case() {
        return UnicourtCase;
    },
};

export { DOMAIN, getStore };
export const getAsync = state => getStore(state).__async__ || {};
export const getAsyncForSchema = (state, schema = {}) => {
    try {
        return getAsync(state)[schema.key] || {};
    } catch (e) {
        return {};
    }
};
export const getAsyncForEntity = (state, { schema, id }) =>
    get(getAsyncForSchema(state, schema), id);
export const isEntityLoading = (state, { schema, id }) =>
    !!getAsyncForEntity(state, { schema, id });
export const isEntityFieldLoading = (state, { schema, id, field }) =>
    !!(getAsyncForEntity(state, { schema, id }) || {})[field];
